import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-corner-card',
  templateUrl: './corner-card.component.html',
  styleUrl: './corner-card.component.scss'
})
export class CornerCardComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input({ required: true }) image!: string;
  @Input({ required: true }) alt!: string;
}